import { render, staticRenderFns } from "./FooterLDP.vue?vue&type=template&id=4b59d0f1&scoped=true"
import script from "./FooterLDP.vue?vue&type=script&lang=js"
export * from "./FooterLDP.vue?vue&type=script&lang=js"
import style0 from "./FooterLDP.vue?vue&type=style&index=0&id=4b59d0f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b59d0f1",
  null
  
)

export default component.exports